import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Demo Request API
export const submitDemoRequest = async (formData) => {
  try {
    const response = await axios.post(`${API}/demo-request`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting demo request:', error);
    throw error;
  }
};

export const getDemoRequests = async () => {
  try {
    const response = await axios.get(`${API}/demo-requests`);
    return response.data;
  } catch (error) {
    console.error('Error fetching demo requests:', error);
    throw error;
  }
};

// Pilot Application API
export const submitPilotApplication = async (formData) => {
  try {
    const response = await axios.post(`${API}/pilot-application`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting pilot application:', error);
    throw error;
  }
};

export const getPilotApplications = async () => {
  try {
    const response = await axios.get(`${API}/pilot-applications`);
    return response.data;
  } catch (error) {
    console.error('Error fetching pilot applications:', error);
    throw error;
  }
};
